<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អ្នកដឹកជញ្ជូនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតអ្នកដឹកជញ្ជូនថ្មី" name="second"></el-tab-pane>
			<el-tab-pane label="តាមដានការស្កេនកញ្ចប់ឥវ៉ាន់" name="third" v-if="allow_user('sa|da')"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-30">
					<md-field>
						<label>ស្ថានភាព (ទាំងអស់)</label>
						<md-select placeholder="ស្ថានភាព (ទាំងអស់)" v-model="search.status">
							<md-option value="">ទាំងអស់</md-option>
							<md-option value="act">ដំណើរការ</md-option>
							<md-option value="nat">មិនដំណើរការ</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក
					</md-button>
				</div>
			</div>

			<md-table v-if="driverList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ.</md-table-head>
					<md-table-head>លេខ​ ID</md-table-head>
					<md-table-head>ឈ្មោះ និងលេខទូរស័ព្ទ</md-table-head>
					<md-table-head>តេឡេក្រាម</md-table-head>
					<!-- <md-table-head>កំណត់ចំណាំ</md-table-head> -->
					<md-table-head>ថ្ងៃបង្កើត</md-table-head>
					<md-table-head>អាចស្កេនចេញ</md-table-head>
					<md-table-head>ស្ថានភាព</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(driver, index) in driverList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell>
						<img src="@/assets/img/default-driver.png" style="width: 34px; margin-right:5px">
						{{ driver.hash_id }}
					</md-table-cell>
					<md-table-cell>{{ driver.name }}<br>{{ driver.phone }}</md-table-cell>
					<md-table-cell>{{driver.telegram_link}}</md-table-cell>
					<md-table-cell>{{ config.datelify(driver.created_date) }}</md-table-cell>
					<md-table-cell>
						<span class="green" v-if="driver.checkout == 1">{{config.getStatus(driver.checkout)}}</span>
						<span class="late" v-if="driver.checkout == 0">{{config.getStatus(driver.checkout)}}</span>
					</md-table-cell>
					<md-table-cell>
						<span class="green" v-if="driver.status == 'act'">{{config.getStatus(driver.status)}}</span>
						<span class="late" v-if="driver.status == 'nac'">{{config.getStatus(driver.status)}}</span>
					</md-table-cell>
					<md-table-cell>
						<router-link :to="'/drivers/detail/' + driver.hash_id" v-if="allow_user('sa|ad')">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បង្ហាញបន្ថែម</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/drivers/edit/' + driver.hash_id" v-if="allow_user('sa|ad')">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<router-link :to="'/print_driver_package_label/' + driver.hash_id" v-if="allow_user('sa|ad|da')">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>print</md-icon>
								<md-tooltip md-direction="top">បោះពុម្ភស្លាកកញ្ចប់ឥវ៉ាន់</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-primary" @click="checkout(driver.hash_id, driver.checkout)" v-if="allow_user('sa|ad|da')">
							<span v-if="driver.checkout == 1">
								<md-icon>qr_code_scanner</md-icon>
								<md-tooltip md-direction="top">បិទអនុញ្ញាតស្កេនចេញ</md-tooltip>
							</span>
							<span v-else>
								<md-icon class="md-success">qr_code_scanner</md-icon>
								<md-tooltip md-direction="top">អនុញ្ញាតស្កេនចេញ</md-tooltip>
							</span>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="activate(driver.id, driver.status)" v-if="allow_user('sa|ad|da')">
							<span v-if="driver.status == 'act'">
								<md-icon>block</md-icon>
								<md-tooltip md-direction="top">ផ្អាកដំណើរការ</md-tooltip>
							</span>
							<span v-else>
								<md-icon>done</md-icon>
								<md-tooltip md-direction="top">ដាក់ឱ្យដំណើរការ</md-tooltip>
							</span>
						</md-button>
						<md-button class="md-just-icon md-simple md-danger" @click="deleteDriver(driver.id)" v-if="allow_user('sa')">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="driverList.length == 0 && loadMore == true">មិនមានទិន្នន័យ</h4>
			<!-- <div class="places-buttons text-center" v-if="loadMoreCompanyButton" >
				<md-button class="md-primary" @click="getCompany(companyList.length, false)">បង្ហាញបន្ថែម</md-button>
			</div> -->
		</div>

		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអ្នកដឹកជញ្ជូន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ឈ្មោះអ្នកដឹកជញ្ជូន *</label>
								<md-input type="text" v-model="driver.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្អអ្នកដឹកជញ្ជូន *</label>
								<md-input type="text" v-model="driver.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ពាក្យសម្ងាត់ *</label>
								<md-input type="password" v-model="driver.password">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>បញ្ជាក់ពាក្យសម្ងាត់ *</label>
								<md-input type="password" v-model="driver.confirm_password">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>តេឡេក្រាម</label>
								<md-input type="text" v-model="driver.telegram_link">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>កំណត់ចំណាំផ្សេងៗ</label>
								<md-input type="text" v-model="driver.note">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអ្នកដឹកជញ្ជូន</md-table-cell>
								<md-table-cell style="width: 5px">៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.name).length > 0">{{driver.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.phone).length > 0">{{driver.phone}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>តេឡេក្រាម</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.telegram_link).length > 0">{{driver.telegram_link}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>៖</md-table-cell>
								<md-table-cell>
									<span v-if="String(driver.note).length > 0">{{driver.note}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postDriver()">បង្កើត</md-button>
				</div>
			</div>
		</div>
		
		<div v-if="tabName == 'third'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-50 md-size-20">
					<md-field>
						<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ ID</label>
						<md-input v-model="driverTrackingSearch.text" type="text" @keyup.enter="searchTrackingHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-50 md-size-20">
					<md-field>
						<label>ថ្ងៃស្វែងរក</label>
						<md-input type="text" v-model="driverTrackingSearch.date" style="display:none" />
						<datetime type="date" v-model="driverTrackingSearch.date" zone="local" value-zone="UTC" auto></datetime>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-primary" @click="today()">ថ្ងៃនេះ</md-button>
					<md-button class="md-primary" @click="yesterday()">ម្សិលមិញ</md-button>
					<md-button class="md-raised md-primary" @click="searchTrackingHandler()">ស្វែងរក</md-button>
				</div>
				<div class="md-layout-item md-size-20">{{total_package}} កញ្ចប់</div>
				
			</div>

			<md-card v-for="(driver, index) in driverTrackingList">
				<md-card-content>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100" style="display: flex; flex-direction: row; align-items: center;">
							<h4 class="title">{{index+1}}. <b>{{driver.hash_id}}  {{driver.name}}</b> ({{driver.phone}}) - ({{driver.packageList.length}} កញ្ចប់)</h4>
							<md-button class="md-just-icon md-simple md-success" @click="display(driver.packageList)">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">បើកមើល</md-tooltip>
							</md-button>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row>
									<md-table-head>ល.រ.</md-table-head>
									<md-table-head>រូបភាពកញ្ចប់ឥវ៉ាន់</md-table-head>
									<md-table-head>លេខកូដ</md-table-head>
									<md-table-head>កាលបរិច្ឆេទបញ្ចូល</md-table-head>
									<md-table-head>បញ្ចូលដោយ</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(pkg, index) in driver.packageList">
									<md-table-cell>{{ index + 1 }}</md-table-cell>
									<md-table-cell>
										<img :src="config.getPackageUrl(pkg.image_url)" class="package-image" />
									</md-table-cell>
									<md-table-cell><b>{{ pkg.hash }}</b></md-table-cell>
									<md-table-cell>{{ config.datelify(pkg.created_date) }}</md-table-cell>
									<md-table-cell>{{pkg.scan_by}}</md-table-cell>
									<md-table-cell>
										<md-button class="md-just-icon md-simple md-danger" @click="remove_track_package(pkg.hash)" v-if="allow_user('sa')">
											<md-icon>close</md-icon>
											<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
										</md-button>
									</md-table-cell>
									
								</md-table-row>
							</md-table>
						</div>
					</div>
				</md-card-content>
			</md-card>
			<transition name="fade" mode="out-in">
				<div class="md-overlay md-fixed md-dialog-overlay" v-show="action.show" @click="close_dialog()"></div>
			</transition>
			<div class="md-dialog md-theme-default dialog-container" v-if="action.show">
				<div v-for="(pkg, index) in action.packageList" class="package-container">
					<h3>{{index+1}}. {{pkg.hash}}</h3><br>
					<img :src="config.getPackageUrl(pkg.image_url)" style="width: 70%; height: auto;"/>
				</div>
				<div><md-button class="md-raised md-danger" @click="close_dialog()">បិទផ្ទាំង</md-button></div>
			</div>
		</div>

		<md-dialog-confirm :md-active.sync="deleteDialog" md-title="តើអ្នកពិតជាចង់លុបអ្នកដឹកនេះពិតមែនទេ ?"
			md-content="ព័ត៌មានរបស់អ្នកដឹកនឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="deleteDriver" />
		<md-dialog-confirm :md-active.sync="removeTrackPackageDialog" md-title="តើអ្នកពិតជាចង់លុបកញ្ចប់នេះពិតមែនទេ ?"
			md-content="ព័ត៌មានរបស់កញ្ចប់នឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="remove_track_package" />
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			// this.getTransaction();
			this.searchHandler();
		},
		data() {
			return {
				tabName: "first",
				loaded: false,
				search: {
					text: "",
					status: ""
				},
				deleteID: "",
				deleteDialog: false,
				removeTrackPackageID: "",
				removeTrackPackageDialog: false,
				driver: {
					valid: false,
					name: "",
					phone: "",
					telegram_link: "",
					password: "",
					confirm_password: "",
					note: ""
				},
				action: {
					show: false,
					packageList: []
				},
				loadMore: true,
				driverList: [],
				driverTrackingSearch: {
					text: "",
					date: ""
				},
				driverTrackingList: []
			}
		},
		computed: {
			total_package() {
				let total = 0;
				for(let i = 0; i < this.driverTrackingList.length;i++) {
					total = this.driverTrackingList[i].packageList.length;
				}
				return total;
			}
		},
		watch: {
			'tabName': function(val) {

				if(val == "third") {
					this.driverTrackingSearch.date = (new Date()).toISOString();
					console.log(this.driverTrackingSearch.date)
					this.searchTrackingHandler();
				}
			},
			'driverTrackingSearch.date': function(val) {
				this.searchTrackingHandler();
			}
		},
		methods: {
			close_dialog() {
				this.action.show = false;
				this.action.packageList = [];
			},
			display(packageList) {
				this.action.show = true;
				this.action.packageList = packageList;
			},
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.tagList = data.body.data.tag
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/driver/search", {
					text: this.search.text,
					status: this.search.status,
					offset: more ? this.driverList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.driverList = data.body.data;
				})
			},
			searchTrackingHandler(more = false) {
				this.$http.post(this.config.api + "/admin/driver/tracking_search", {
					text: this.driverTrackingSearch.text,
					date: String(this.driverTrackingSearch.date).split("T")[0],
					offset: more ? this.driverTrackingList.length : 0
				}).then(data => {
					this.driverTrackingList = data.body.data;
				})
			},
			checkValidation() {
				if (String(this.driver.name).length > 0 && String(this.driver.phone).length > 0 && String(this.driver.password).length > 0 && String(this.driver.confirm_password).length > 0) {
					if (String(this.driver.password) == String(this.driver.confirm_password)) {

						if (String(this.driver.password).length > 5) {
							return true;
						} else {
							this.$notification.notify({
								message: "ពាក្យសម្ងាត់ត្រូវមានចាប់ពី ៦តួរអក្សឡើង។",
								icon: 'error',
								type: 'danger'
							})
						}
					} else {
						this.$notification.notify({
							message: "ពាក្យសម្ងាត់ និង បញ្ជាក់ពាក្យសម្ងាត់មិនដូចគ្នា។",
							icon: 'error',
							type: 'danger'
						})
					}
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			},
			deleteDriver(id) {
				if (String(this.deleteID).length > 0) {
					let id = this.deleteID;
					this.onCancel();
					this.$http.post(this.config.api + "/admin/driver/delete", {
						id: id,
					}).then(res => {
						if (res.body.status == 'success') {

							this.searchHandler();

						}
					})
				} else {
					this.deleteID = id;
					this.deleteDialog = true;
				}
			},
			activate(id, status) {
				let update_status = 'act';
				if (status == 'act') update_status = 'nac';

				this.$http.post(this.config.api + "/admin/driver/activate", {
					id: id,
					status: update_status
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.tabName = 'first'
						this.searchHandler();

					}
				})
			},
			checkout(hash_id, status) {
				let update_status = 0;
				if (status == 0) update_status = 1;

				this.$http.post(this.config.api + "/admin/driver/checkout", {
					hash_id: hash_id,
					status: update_status
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.tabName = 'first'
						this.searchHandler();

					}
				})
			},
			remove_track_package(hash) {
				if(this.removeTrackPackageID == "") {
					this.removeTrackPackageID = hash;
					this.removeTrackPackageDialog = true;
					return false;
				}
				this.$http.post(this.config.api + "/admin/driver/remove_track_package", {
					hash_id: this.removeTrackPackageID
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "ជោគជ័យ។", icon: 'done', type: 'success' });
					}
					this.searchTrackingHandler();
					this.onCancel();
				})
			},
			postDriver() {
				if (this.checkValidation()) {
					this.$http.post(this.config.api + "/admin/driver/post", {
						driver: this.driver
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "អ្នកដឹកជញ្ជូនត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.tabName = 'first';
							this.clear();
							this.searchHandler();

						}
					})
				}
			},
			today() {
				this.driverTrackingSearch.date = (new Date()).toISOString();
				this.searchTrackingHandler();
			},
			yesterday() {
				let date = new Date();
				date.setDate(date.getDate() - 1);
				this.driverTrackingSearch.date = date.toISOString();
				this.searchTrackingHandler();
			},
			clear() {
				this.driver = {
					valid: false,
					name: "",
					phone: "",
					password: "",
					confirm_password: "",
					note: ""
				}
			},
			onCancel() {
				this.deleteID = "";
				this.deleteDialog = false;
				this.removeTrackPackageID = "";
				this.removeTrackPackageDialog = false;
			}
		}
	}
</script>
<style scoped>
	.package-image {
		max-height: 65px;
		width: auto;

	}
	.package-container {
		width: 100%;
		text-align: center;
	}
	.dialog-container {
		width: 95%;
		max-width: 95% !important;
		max-height: 95%;
		height: 90%;
		padding: 15px;
		border-radius: 6px;
		flex-direction: column;
		overflow-y: scroll;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .1s
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}
</style>


// WEBPACK FOOTER //
// src/pages/Drivers/View.vue